<template>
  <div class="pt-20 p-4 flex flex-col items-center bg-light-bg dark:bg-dark-bg min-h-screen text-light-text dark:text-dark-text">
    <AppSidebar />

    <div class="w-full max-w-6xl bg-white dark:bg-dark-box-bg rounded-lg shadow-md p-6 mt-6">
      <button
          @click="goToDrivers"
          class="mb-4 text-teal-700 dark:text-teal-400 hover:underline flex items-center"
      >
        &larr; Wróć do zakładki kierowców
      </button>

      <button
          v-if="this.user.role === 'ROLE_ADMIN' || this.user.role === 'ROLE_ADULT_DISPATCHER'"
          @click="showModal = true"
          class="mb-6 px-4 py-2 bg-red-600 text-white dark:bg-red-700 rounded-lg hover:bg-red-700 dark:hover:bg-red-800 transition-colors"
      >
        Zmień hasło użytkownika
      </button>

      <div v-if="driver">
        <h2 class="text-2xl font-bold mb-6">Profil Kierowcy</h2>

        <!-- Driver Information Grid -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-6 mb-6">
          <div class="space-y-2">
            <p><strong>ID:</strong> {{ driver.id }}</p>
            <p><strong>Imie:</strong> {{ driver.firstName || 'Nie podano' }}</p>
            <p><strong>Nazwisko:</strong> {{ driver.lastName || 'Nie podano' }}</p>
            <p><strong>Nazwa użytkownika:</strong> {{ driver.username || 'Nie podano' }}</p>
            <p><strong>Telefon:</strong> {{ driver.phone || 'Nie podano' }}</p>
          </div>
          <div class="space-y-2">
            <!-- <p><strong>Email:</strong> {{ driver.email || 'Nie podano' }}</p> -->
            <p><strong>Miasto:</strong> {{ driver.city || 'Nie podano' }}</p>
            <p><strong>Rok Samochodu:</strong> {{ driver.carYear || 'Nie podano' }}</p>
            <p><strong>Samochód:</strong> {{ driver.car || 'Nie podano' }}</p>
            <p><strong>Status Kierowcy:</strong> {{ driver.driverStatus }}</p>
          </div>
        </div>

        <!-- Missing Information Warnings -->
        <div v-if="!driver.phone || !driver.city" class="mt-4 text-yellow-600 dark:text-yellow-400">
          <p v-if="!driver.phone" class="text-sm">
            <span class="font-bold">⚠️</span> Brak numeru telefonu!
          </p>
          <p v-if="!driver.city" class="text-sm">
            <span class="font-bold">⚠️</span> Brak miasta!
          </p>
        </div>

        <hr class="my-6 border-light-border dark:border-dark-border">

        <!-- Orders Table -->
        <h4 class="text-lg font-semibold mb-4">Zlecone Zamówienia</h4>
        <div class="overflow-x-auto">
          <table class="w-full border-collapse border border-light-border dark:border-dark-border">
            <thead>
            <tr class="bg-light-table-header dark:bg-dark-table-header">
              <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">#</th>
              <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Numer Zamówienia</th>
              <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Data</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(order, index) in driver.orders"
                :key="order.id"
                class="hover:bg-light-hover dark:hover:bg-dark-hover cursor-pointer"
                @click="goToProfile(order)"
            >
              <td class="border border-light-border dark:border-dark-border px-4 py-2">{{ index + 1 }}</td>
              <td class="border border-light-border dark:border-dark-border px-4 py-2 text-teal-700 dark:text-teal-400 hover:underline">
                Zamówienie {{ order.mpk }}
              </td>
              <td class="border border-light-border dark:border-dark-border px-4 py-2">
                {{ new Date(order.date).toLocaleDateString() }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Loading State -->
      <div v-else-if="loading" class="text-gray-500 dark:text-gray-400">
        <p>Ładowanie danych kierowcy...</p>
      </div>

      <!-- Error State -->
      <div v-else-if="errorMessage" class="text-red-500 dark:text-red-400">
        <p>{{ errorMessage }}</p>
      </div>

      <!-- Modal -->
      <div v-if="showModal" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div class="bg-white dark:bg-dark-box-bg rounded-lg shadow-lg p-6 w-96">
          <h3 class="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            Zmień hasło użytkownika
          </h3>
          <input
              v-model="newPassword"
              type="password"
              placeholder="Nowe hasło"
              class="w-full mb-4 p-2 border rounded-lg bg-light-row-odd dark:bg-dark-row-odd text-light-text dark:text-dark-text"
          />
          <div class="flex justify-end">
            <button
                @click="showModal = false"
                class="mr-2 px-4 py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition-colors"
            >
              Anuluj
            </button>
            <button
                @click="changePassword"
                class="px-4 py-2 bg-teal-700 text-white rounded-lg hover:bg-teal-700 dark:bg-teal-500 dark:hover:bg-teal-600 transition-colors"
            >
              Zapisz
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
  import { useAuthStore } from '@/stores/authStore';
  import driversService from '@/services/driversService';
  import AppSidebar from '@/components/AppSidebar.vue';
import settingsService from '@/services/settingsService';
  
  export default {
    name: 'DriverProfile',
    components: {AppSidebar},
    data() {
      return {
        driver: null,
        loading: true,
        errorMessage: '',
        showModal: false,
        newPassword: ''
      };
    },
    setup() {
      const authStore = useAuthStore();
      authStore.checkExpiration();
      return { user: authStore.user };
    },
    mounted() {
      this.fetchDriver();
    },
    methods: {
      async fetchDriver() {
        const driverId = this.$route.params.id || this.$route.query.driverId; // Sprawdź `query`
        if (!driverId) {
          this.errorMessage = 'Brak ID kierowcy.';
          return;
        }
        this.loading = true;
        this.errorMessage = '';
        try {
          const response = await driversService.getDriverById(driverId);
          this.driver = response.data;
        } catch (error) {
          console.error('Error fetching driver details:', error);
          this.errorMessage = 'Nie udało się pobrać szczegółów kierowcy. Spróbuj ponownie później.';
        } finally {
          this.loading = false;
        }
      },
      goToDrivers() {
        const currentPage = this.$route.query.currentPage;
        if (this.user.role === 'ROLE_ADMIN') {
          this.$router.push({ name: 'DriversPageAdmin', query: {currentPage: currentPage} });
        } else {
          this.$router.push({ name: 'DriversPageDispatcher', query: {currentPage: currentPage} });
        }
      },
      goToProfile(order) {
        const role = this.user.role;
        const routeName = role === 'ROLE_ADMIN' ? 'OrderProfileAdmin' : 'OrderProfileDispatcher';
        this.$router.push({
          name: routeName,
          params: { id: order.id },
          query: {
            returnTo: this.$route.name,
            driverId: this.driver.id, // Dodaj ID kierowcy do query
          },
        });
      },
      async changePassword() {
        if (!this.newPassword) {
          alert('Podaj nowe hasło!');
          return;
        }
        try {
          await settingsService.adminChangePassword(this.driver.id, this.newPassword);
          alert('Hasło zostało pomyślnie zmienione!');
          this.showModal = false;
          this.newPassword = '';
        } catch (error) {
          alert('Wystąpił błąd podczas zmiany hasła. Spróbuj ponownie.');
        }
      }
    }
  };
  </script>